import React, { JSX, useContext } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { BenchmarkingFiltersContext } from "@app/overviews/network-benchmarking-dashboard/filters/BenchmarkingFiltersContext";
import { CompetitiveInsightsMap } from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsMap";
import { CompetitiveInsightsViewTypeEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared";
import { MedicareFiltersContext } from "@app/overviews/network-benchmarking-dashboard/medicare/filters/MedicareFiltersContext";
import MedicareNetworkFilters from "@app/overviews/network-benchmarking-dashboard/medicare/filters/MedicareNetworkFilters";
import MedicarePrimaryFilters from "@app/overviews/network-benchmarking-dashboard/medicare/filters/MedicarePrimaryFilters";

interface BenchmarkingFiltersProps {
  isRedesign?: boolean;
  selectedView: CompetitiveInsightsViewTypeEnum;
}

const BenchmarkingFilters = (props: BenchmarkingFiltersProps): JSX.Element => {
  const benchmarkingFiltersContext = useContext(BenchmarkingFiltersContext);
  const medicareFiltersContext = useContext(MedicareFiltersContext);

  return (
    <React.Fragment>
      {!benchmarkingFiltersContext.displayedPrimaryFilters && (
        <div className="row">
          <div className="col-12">
            <label className="copy-text-default mb-3">
              Please begin by selecting and applying your filters to view available networks for comparison.
            </label>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className={!props.isRedesign ? "card card-static" : ""}>
            <div className={!props.isRedesign ? "card-body" : ""}>
              <MedicarePrimaryFilters />

              {(!medicareFiltersContext.primaryFiltersLoading && !!benchmarkingFiltersContext.states?.length) ? (
                props.selectedView === CompetitiveInsightsViewTypeEnum.MapView ? (
                  <CompetitiveInsightsMap
                    networkFiltersLoading={medicareFiltersContext.networkFiltersLoading}
                    parentOrganizations={medicareFiltersContext.parentOrganizations}
                    selectedNetworkCount={benchmarkingFiltersContext.selectedNetworks?.length}
                    showNetworks={!!benchmarkingFiltersContext.displayedPrimaryFilters}
                  />  
                ) : (
                  !!benchmarkingFiltersContext.displayedPrimaryFilters && (
                    <MedicareNetworkFilters />
                  )
                )
              ) : (
                <div className="text-center">
                  <LoadingSpinner />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default BenchmarkingFilters;